import React, { useState } from "react";
import { Palette, Check } from "lucide-react";
import { useTheme } from "../lib/theme";
import { Link } from "react-router-dom";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export function ThemeQuickSwitcher() {
    const { themeId, setTheme, themes, layoutId, setLayout, layouts } = useTheme();
    const [open, setOpen] = useState(false);

    return (
        <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger asChild>
                <button
                    data-testid="theme-quick-switcher-trigger"
                    className="w-9 h-9 rounded-full border border-white/10 bg-white/[0.02] flex items-center justify-center hover:border-primary/50 hover:bg-white/[0.05] transition-colors"
                    aria-label="Theme picker"
                >
                    <Palette className="h-4 w-4 text-muted-foreground" />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-64 bg-card border-border">
                <DropdownMenuLabel className="text-xs uppercase tracking-widest text-muted-foreground">
                    Themes
                </DropdownMenuLabel>
                {Object.values(themes).map((t) => (
                    <DropdownMenuItem
                        key={t.id}
                        onClick={() => setTheme(t.id)}
                        className="cursor-pointer flex items-center gap-3"
                        data-testid={`quick-theme-${t.id}`}
                    >
                        <span
                            className="w-4 h-4 rounded-full ring-1 ring-white/20 shrink-0"
                            style={{ background: t.preview.primary }}
                        />
                        <span className="flex-1 text-sm">{t.name}</span>
                        {themeId === t.id && <Check className="h-4 w-4 text-primary" />}
                    </DropdownMenuItem>
                ))}
                <DropdownMenuSeparator />
                <DropdownMenuLabel className="text-xs uppercase tracking-widest text-muted-foreground">
                    Layout
                </DropdownMenuLabel>
                {Object.values(layouts).map((l) => (
                    <DropdownMenuItem
                        key={l.id}
                        onClick={() => setLayout(l.id)}
                        className="cursor-pointer flex items-center gap-3"
                        data-testid={`quick-layout-${l.id}`}
                    >
                        <span className="flex-1 text-sm">{l.name}</span>
                        {layoutId === l.id && <Check className="h-4 w-4 text-primary" />}
                    </DropdownMenuItem>
                ))}
                <DropdownMenuSeparator />
                <DropdownMenuItem asChild data-testid="quick-open-studio">
                    <Link to="/themes" className="cursor-pointer text-primary text-sm">
                        Open full studio →
                    </Link>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
